
import { defineComponent } from '@nuxtjs/composition-api'
import get from 'lodash/get'

export default defineComponent({
  props: {
    images: { type: Array, required: false, default: () => [] },
    videos: { type: Array, required: false, default: () => [] },
  },
  setup() {
    return { get }
  },
  data() {
    return {
      slickOptions: {
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 1,
        slidesToSlide: 1,
        initialSlide: 0,
        infinite: false,
        dots: true,
        arrows: false,
        appendDots: '.slider-navigation',
        responsive: [
          {
            breakpoint: 200,
            settings: {
              centerMode: true,
              centerPadding: '10px',
              slidesToShow: 1,
              slidesToSlide: 1,
              initialSlide: 0,
              infinite: true,
              arrows: false,
            },
          },
        ],
      },
      modalVisible: false,
    }
  },
  methods: {
    next() {
      this.$refs.slick.next()
    },
    prev() {
      this.$refs.slick.prev()
    },
    getMediaItems() {
      const mediaItems = []
      for (const image of this.images) {
        mediaItems.push({
          image,
          video: undefined,
        })
      }
      for (const video of this.videos) {
        mediaItems.push({
          image: undefined,
          video,
        })
      }
      return mediaItems
    },
  },
})
